import type { ReactNode } from "react"
import { ButtonBase, Stack, Typography } from "@mui/material"

interface OpcaoCardProps {
    icone: ReactNode
    rotulo: string
    onClick: () => void
    desabilitado?: boolean
}

export default function OpcaoCard({ icone, rotulo, onClick, desabilitado = false }: OpcaoCardProps): JSX.Element {
    return (
        <ButtonBase
            onClick={onClick}
            disabled={desabilitado}
            sx={{
                width: '100%',
                minHeight: 180,
                borderRadius: 4,
                p: 4,
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'background.paper',
                transition: 'transform 0.2s ease-in-out, border-color 0.2s ease-in-out',

                '&:hover': {
                    borderColor: 'primary.main',
                    transform: 'translateY(-2px)',
                },

                '&:active': {
                    transform: 'scale(0.98)',
                },

                '&.Mui-disabled': {
                    opacity: 0.5,
                },
            }}
        >
            <Stack spacing={2} sx={{ alignItems: 'center', justifyContent: 'center' }}>
                {icone}

                <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                    {rotulo}
                </Typography>
            </Stack>
        </ButtonBase>
    )
}